import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div className="language-switcher">
      <button
        className="language-switcher-trigger"
        onClick={toggleDropdown}
        aria-label="Выбор языка / Language selector"
        aria-expanded={isOpen}
      >
        <FaGlobe aria-hidden="true" />
        <span>{i18n.language?.startsWith('en') ? 'EN' : 'RU'}</span>
      </button>

      {isOpen && (
        <div className="language-switcher-dropdown">
          <button
            className={`d-flex align-items-center w-100 px-3 py-2 border-0 bg-transparent ${i18n.language === 'en' ? 'text-primary' : 'text-white'}`}
            onClick={() => {
              i18n.changeLanguage('en');
              setIsOpen(false);
            }}
            style={{ cursor: 'pointer' }}
          >
            <img 
              src="https://flagcdn.com/w20/gb.png"
              srcSet="https://flagcdn.com/w40/gb.png 2x"
              width="20" 
              alt="English"
              className="me-2"
            />
            English
          </button>
          <button
            className={`d-flex align-items-center w-100 px-3 py-2 border-0 bg-transparent ${i18n.language === 'ru' ? 'text-primary' : 'text-white'}`}
            onClick={() => {
              i18n.changeLanguage('ru');
              setIsOpen(false);
            }}
            style={{ cursor: 'pointer' }}
          >
            <img 
              src="https://flagcdn.com/w20/ru.png"
              srcSet="https://flagcdn.com/w40/ru.png 2x"
              width="20" 
              alt="Russian"
              className="me-2"
            />
            Русский
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;